import { render, staticRenderFns } from "./DetailSetting.vue?vue&type=template&id=d4cdc430&scoped=true&"
import script from "./DetailSetting.vue?vue&type=script&lang=js&"
export * from "./DetailSetting.vue?vue&type=script&lang=js&"
import style0 from "./DetailSetting.vue?vue&type=style&index=0&id=d4cdc430&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cdc430",
  null
  
)

export default component.exports